import Tools from '../misc/Tools.js'

const threshold = 0.8;
const optpriority = {'(':0, 'and':1, 'or':2};
const optmap = {'and':'&&', 'or':'||', '<>':'!=', '=':'=='};
const getoriexp = function(exp) {
    if (exp.target) {
        var getprops = 'data["' + exp.target + '"]';//exp.target == '__DATA_KEY__' ? 'target.datakey(data)' : ('data.props("' + exp.target + '")');
        var oriexp = '';
        switch (exp.opt) {
            case 'is null':
                oriexp = getprops + (exp.not ? '!==null' : '===null')
                break;
            case 'like':
                oriexp = (exp.not ? '!' : '') + exp.value + '.test(' + getprops + ')';
                break;
            case 'in':
                oriexp = '(' + JSON.stringify(exp.value) + ')[' + getprops + (exp.not ? ']===undefined' : ']!==undefined');
                break;
            default:
                var opt = optmap[exp.opt] || exp.opt;
                if (exp.not) {
                    switch (exp.opt) {
                        case '>': opt = '<='; break;
                        case '>=': opt = '<'; break;
                        case '<': opt = '>='; break;
                        case '<=': opt = '>'; break;
                        case '==': opt = '!='; break;
                        case '!=': opt = '=='; break;
                    }
                }
                if (exp.ignocase) oriexp = '(' + getprops + ').toLowerCase() ' + opt + ' (' + JSON.stringify(exp.value) + '+"").toLowerCase()';
                else oriexp = getprops + ' ' + opt + ' ' + JSON.stringify(exp.value);
                break;
        }
        return oriexp;
    }
    return '(' + getoriexp(exp.left) + ' ' + optmap[exp.opt] + ' ' + getoriexp(exp.right) + ')';
}
const convertcondition = function(condition, strmap, defaultfield, indexmap) {
    condition.match(/^(?:\s*(not)\s+)?\s*([\w\.]+)?\s*(?:\s+(not)\s+)?(!?=|<>|>=?|<=?|like|in|is)?(?:\s+(not)\s+)?\s*(\[.*\]|[^\s\[\]]+)\s*$/i);
    var target = RegExp.$2;
    var not = !!(RegExp.$1 || RegExp.$3 || RegExp.$5);
    var opt = RegExp.$4.toLowerCase();
    var value = null;
    var oriexp = null;
    var ignocase = false;
    if (opt == 'is') {
        opt = 'is null';
        // oriexp = 'data.' + target + (not ? '!==null' : '===null');
    } else {
        value = RegExp.$6.replace(/\{(\d+)\}/g, function($0, $1) { return '"' + strmap[$1] + '"' }).replace(/\i$/i, function($0) {
            ignocase = true;
            return '';
        });
        value = eval(value);
        switch (opt) {
            case 'like':
                value = new RegExp('^' + value.replace(/(%)|(_)|(\w)|(.)/g, function($0, $1, $2, $3, $4) {
                    if ($1) return '.*';
                    else if ($2) return '.';
                    else if ($3) return $3;
                    else if ($4) return '\\' + $4;
                }) + '$', ignocase ? 'i' : '');
                // oriexp = (not ? '!' : '') + value + '.test(data.' + target + ')';
                break;
            case 'in':
                var v = {};
                for (var i = 0; i < value.length; i++) {
                    v[value[i]] = true;
                }
                value = v;
                // oriexp = '(' + JSON.stringify(value) + ')[data.' + target + (not ? ']===undefined' : ']!==undefined');
                break;
            default:
                // if (ignocase) oriexp = '(data.' + target + ' + "").toLowerCase() ' + (optmap[opt] || opt) + ' (' + JSON.stringify(value) + ' + "").toLowerCase()';
                // else oriexp = 'data.' + target + ' ' + (optmap[opt] || opt) + ' ' + JSON.stringify(value);
                // if (not) oriexp = '!(' + oriexp + ')'
                break;
        }
    }
    if (!target) {
        target = defaultfield;
        opt = '=='
    }
    var w = indexmap && indexmap[target] !== undefined ? 1 : 0;
    return {target:target, opt:optmap[opt] || opt, not:not, ignocase:ignocase, value:value, /*oriexp:oriexp, */count:1, weight:w, allweight:w};
}

const notfunc = function(exp) {
    if (exp.target) {
        exp.not = !exp.not;
    } else {
        exp.opt = exp.opt == 'and' ? 'or' : 'and';
        notfunc(exp.left);
        notfunc(exp.right);
    }
    return exp;
}
const createexpression = function(defaultfield, indexmap, strmap, conditions, operators, conindex, optindex, left, once) {
    var opt1 = operators[optindex];
    var not = false;
    if (/not\s*\(/i.test(opt1)) {
        not = true;
        opt1 = '(';
    }
    if (!left) left = convertcondition(conditions[conindex], strmap, defaultfield, indexmap);
    if (opt1 == '(') {
        var obj = createexpression(defaultfield, indexmap, strmap, conditions, operators, conindex, optindex + 1);
        left = obj.exp;
        left.specopt = '()';
        if (not) notfunc(left);
        // left.oriexp = '!' + left.oriexp;
        optindex = obj.optindex;
        conindex = obj.conindex;
        opt1 = operators[++optindex];
        if (conditions[conindex + 1] === undefined) return {exp:left, conindex:conindex, optindex:optindex};
    }
    var right = convertcondition(conditions[++conindex], strmap, defaultfield, indexmap);
    var opt2 = operators[++optindex];
    while (opt2 && opt2 != ')') {
        if (/not\s*\(/i.test(opt1)) {
            not = true;
            opt2 = '(';
        }
        if (optpriority[opt1] <= optpriority[opt2]) {
            var c = left.count + right.count;
            var w = left.allweight + right.allweight;
            left = {left:left, opt:opt1, right:right, /*oriexp:getoriexp(left, opt1, right), */count:c, weight:w / c, allweight:w};
            if (once) return {exp:left, conindex:conindex, optindex:optindex};
            opt1 = opt2;
            var right = convertcondition(conditions[++conindex], strmap, defaultfield, indexmap);
            var opt2 = operators[++optindex];
        } else {
            if (opt2 == '(') optindex++;
            var obj = createexpression(defaultfield, indexmap, strmap, conditions, operators, conindex, optindex, right, opt2 != '(');
            right = obj.exp;
            optindex = obj.optindex;
            if (opt2 == '(') {
                right.specopt = '()';
                if (not) notfunc(right);
                // right.oriexp = '!' + right.oriexp;
                optindex++;
            }
            conindex = obj.conindex;
            opt2 = operators[optindex];
        }
        if (once) break;
    }
    var c = left.count + right.count;
    var w = left.allweight + right.allweight;
    return {exp:{multiple:true, left:left, opt:opt1, right:right, /*oriexp:getoriexp(left, opt1, right), */count:c, weight:w / c, allweight:w}, conindex:conindex, optindex:optindex};
}

class ConditionAnalyzer {
   static analyze(condition, defaultfield, indexmap) {
        var condobj = Tools.getQuotes(condition);
        var strmap = condobj.strmap;
        condition = condobj.output;
        condition = condition.replace(/in\s*\(([^\)]*)\)/ig, 'in [$1]');
        var operators = condition.match(/\sand\s|\sor\s|(not\s*)?\(|\)/ig);
        var conditions = condition.replace(/(not\s*)?\(|\)/ig, '').replace(/^\s+|\s+$/g, '').split(/\s+and\s+|\s+or\s+/i);
        if (operators) {
            for (var i = 0; i < operators.length; i++) operators[i] = operators[i].replace(/\s/g, '').toLowerCase();
            for (let i = operators.length - 1; i >= 0; i--) {
                if (operators[i] == ')' && operators[i - 1] == '(') {
                    operators.splice(i - 1, 2);
                    i--;
                }
            }
        }
        var exp = operators ? createexpression(defaultfield, indexmap, strmap, conditions, operators, 0, 0).exp : convertcondition(conditions[0], strmap, defaultfield, indexmap);
        if (exp.weight < threshold || threshold >= 1) {
            if (exp.target != null || threshold >= 1 || (exp.left.weight < threshold && exp.right.weight < threshold)) exp = {testFunc:new Function('data', 'target', 'return ' + getoriexp(exp))};
            else if (exp.left.weight < threshold) exp.left = {testFunc:new Function('data', 'target', 'return ' + getoriexp(exp.left))};
            else exp.right = {testFunc:new Function('data', 'target', 'return ' + getoriexp(exp.right))};
        }
        return exp;
    }
    static toObject(condition) {
        var condobj = Tools.getQuotes(condition);
        var strmap = condobj.strmap;
        condition = condobj.output;
        condition = condition.replace(/in\s*\(([^\)]*)\)/ig, 'in [$1]');
        var operators = condition.match(/\sand\s|\sor\s|(not\s*)?\(|\)/ig);
        var conditions = condition.replace(/(not\s*)?\(|\)/ig, '').replace(/^\s+|\s+$/g, '').split(/\s+and\s+|\s+or\s+/i);
        if (operators) for (var i = 0; i < operators.length; i++) operators[i] = operators[i].replace(/\s/g, '').toLowerCase();
        return operators ? createexpression(null, null, strmap, conditions, operators, 0, 0).exp : convertcondition(conditions[0], strmap, null, null);
    }
}

export default ConditionAnalyzer;